import React from 'react';
import cn from 'classnames';

import Card from '../Card';
import Text from '../Text';
import Share from '../Share';
import BookCover from '../BookCover';

import * as styles from './Book.module.css';
import * as textStyles from '../../styles/text.module.css';
import { externalLink } from '../../util';

const Book = ({ headline, intro, text, byLine, book, id, slug }) => {
  const cover = (
    <BookCover
      shadow={book.shadow}
      coverImage={book.image}
      bookName={book.title}
      className={cn(styles.bookImage)}
    />
  );
  return (
    <Card id={id} title="Un libro" className={cn(styles.root)} animate>
      <div className={cn(styles.wrapper)}>
        <div className={cn(styles.intro)}>
          <h2 className={cn(textStyles.headline, styles.introHeadline)}>
            {headline}
          </h2>
          <div className={cn(styles.introByLine)}>
            <p className={styles.name}>Por {byLine.name}</p>
            <p>
              {byLine.role}
              {byLine.role && byLine.company && ', '}
              {byLine.company}
            </p>
          </div>
          <Text className={styles.introText} text={intro} />
        </div>

        <div className={cn(styles.text)}>
          <Text text={text} />

          <figure className={cn(styles.book)}>
            {book.url ? (
              <a href={book.url} {...externalLink}>
                {cover}
              </a>
            ) : (
              cover
            )}
            <figcaption>
              <div className={cn(styles.bookTitle)}>{book.title}</div>
              <div className={cn(styles.bookAuthor)}>{book.author}</div>
              <div className={cn(styles.bookPublisher)}>{book.publisher}</div>
              <div className={cn(styles.bookInfo)}>{book.info}</div>
              {book.url && book.cta && (
                <a
                  href={book.url}
                  className={cn(styles.bookCta)}
                  {...externalLink}
                >
                  {book.cta} →
                </a>
              )}
            </figcaption>
          </figure>
        </div>
        <Share url={`${slug}#${id}`} className={cn(styles.share)} />
      </div>
    </Card>
  );
};

export default Book;
